// TOP LEVEL IMPORTS
import React from 'react';

// ANTD
import Tag from 'antd/lib/tag';

// MODULES
import GeneralHelpers from 'lib/helpers/GeneralHelpers';
import CurrencyHelpers from 'lib/helpers/CurrencyHelpers';

// COMPONENTS
import DeleteButton from 'components/common/DeleteButton';
import ActionMenu from './ActionMenu';

// This function returns only the requested set of columns. showCols = ['number', ...]
const columns = ({ showCols }) => {
  // List of all available columns
  const cols = {
    number: {
      title: '#',
      dataIndex: 'number',
      key: 'number',
    },
    amount: {
      title: 'AMOUNT',
      dataIndex: 'amount',
      key: 'amount',
      render: (text, record) => {
        let symbol = CurrencyHelpers.getCurrencySymbol(record.currency); // put in a currency like "USD" and it returns the symbol, like '$' or the euro symbol
        let amount = CurrencyHelpers.centsToDollars(record.amount, { symbol });
        return record.amount ? <span>{amount}</span> : <span />;
      },
    },
    paidOn: {
      title: 'PAID ON',
      dataIndex: 'paidAt',
      key: 'paidAt',
      render: (text, record) => record.paidAt ? <span>{GeneralHelpers.formatTableDate(record.paidAt)}</span> : <Tag>UNPAID</Tag>,
    },
    paidOn: {
      title: 'DUE',
      dataIndex: 'due',
      key: 'due',
      render: (text, record) => <span>{GeneralHelpers.formatTableDate(record.due)}</span>,
    },
    sentOn: {
      title: 'SENT',
      dataIndex: 'sentAt',
      key: 'sentAt',
      render: (text, record) => (record.sentAt ? <span>{GeneralHelpers.formatTableDate(record.sentAt)}</span> : null),
    },
    status: {
      title: 'STATUS',
      dataIndex: 'status',
      key: 'status',
      render: (text, record) => {
        switch (record.status) {
        case 'DRAFT':
          return <Tag>DRAFT</Tag>;
        case 'SENT':
          return <Tag color="yellow">SENT</Tag>;
        case 'PAID':
          return <Tag color="green">PAID</Tag>;
        case 'SCHEDULED':
          return <Tag color="yellow">SCHEDULED</Tag>;
        default:
          return null;
        }
      },
    },
    actions: {
      title: 'ACTIONS',
      width: 85,
      render: (text, record) => <ActionMenu record={record} />,
    },
    delete: {
      title: 'DELETE',
      width: 75,
      render: (text, record) => (
        <DeleteButton id={record._id} record={record} itemType="Invoice" deleteFunc="deleteInvoice" />
      ),
    },
  };

  // Result list of columns to display
  const res = [];

  // Push only the requested columns (showCols) end return
  for (let i = 0; i < showCols.length; i += 1) {
    const colName = showCols[i];
    res.push(cols[colName]);
  }

  return res;
};

export default columns;



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/ClientInvoices/columns.js